module.exports = __webpack_public_path__ + "./docs/img/big-icon-class.c75e47cfc37a40abff406b0585e56ab5.svg";